// livekitService.js
import { api } from './authService'; // Импортируем экземпляр axios из authService

const LIVEKIT_URL = 'wss://lk.kingdomboardgames.ru';
const TOKEN_KEY = 'videochat_token';

export const livekitService = {
  getStoredToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  async getToken(identity, roomName = 'general') {
    try {
      const cleanRoomName = roomName.replace('#', '').trim();
      
      const url = `/Token?identity=${encodeURIComponent(identity)}&roomName=${encodeURIComponent(cleanRoomName)}`;
      
      // Используем импортированный api
      const response = await api.get(url);
      
      if (!response.data.token) {
        throw new Error('Токен не получен от сервера');
      }
      
      return response.data.token;
    } catch (error) {
      console.error('Ошибка при получении токена LiveKit:', error);
      throw error;
    }
  },

  getServerUrl() {
    return LIVEKIT_URL;
  },

  isAuthenticated() {
    return !!localStorage.getItem(TOKEN_KEY);
  }
};